import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import AnniversaryPage from '../pages/AnniversaryPage';
import '../styles/AnniversaryOverlay.css';

const AnniversaryOverlay = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isClosedManually, setIsClosedManually] = useState(
        sessionStorage.getItem('anniversary_banner_closed') === 'true'
    );

    useEffect(() => {
        // Listen to the admin toggle in Realtime Database
        const anniversaryRef = ref(database, 'appConfig/anniversary_active');
        const unsub = onValue(anniversaryRef, (snapshot) => {
            const isActive = snapshot.val() || false;
            setIsVisible(isActive);
        });

        return () => unsub();
    }, []);

    const handleClose = () => {
        setIsClosedManually(true);
        sessionStorage.setItem('anniversary_banner_closed', 'true');
    };

    if (!isVisible || isClosedManually) return null;

    return (
        <div className="anniversary-overlay-backdrop">
            <div className="anniversary-overlay-content">
                <button className="overlay-close-btn" onClick={handleClose} aria-label="Cerrar aniversario">
                    &times;
                </button>
                <div className="overlay-scroll-container">
                    <AnniversaryPage />
                </div>
            </div>
        </div>
    );
};

export default AnniversaryOverlay;
